module.exports = __webpack_public_path__ + "static/media/aras-digital.7716e26b.png";